import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { imguser } from '../../imagepath';
import BreadCrumbs from '../../core/BreadCrumbs';
import { Button, Col, Row } from 'antd';
import { useUserProfile } from '../../../hooks/useUserProfile';
const BREAD_CRUMBS = [
  { label: 'Dashboard', to: '/user/admin-dashboard' },
  { label: 'My Profile', to: '/profile' },
];
const Profile = () => {
  const { userProfile } = useUserProfile();
  const navigate = useNavigate();

  return (
    <div>
      <BreadCrumbs items={BREAD_CRUMBS} />
      <div className="card-box profile-header">
        <Row gutter={[32, 32]}>
          <Col xs={24} sm={24} md={4}>
            <div className="d-flex justify-content-center">
              <Link to="#">
                <img
                  className="profile-image-view"
                  src={userProfile?.profileImageUrl || imguser}
                  alt=""
                />
              </Link>
            </div>
          </Col>
          <Col xs={24} sm={24} md={20}>
            <h3 className="user-name mb-3">{userProfile?.fullName}</h3>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={8} md={8}>
                <span className="title">First Name:</span>
              </Col>
              <Col xs={24} sm={16} md={16}>
                <span className="text">{userProfile?.firstName}</span>
              </Col>
              <Col xs={24} sm={8} md={8}>
                <span className="title">Last Name:</span>
              </Col>
              <Col xs={24} sm={16} md={16}>
                <span className="text">{userProfile?.lastName}</span>
              </Col>
              <Col xs={24} sm={8} md={8}>
                <span className="title">Email:</span>
              </Col>
              <Col xs={24} sm={16} md={16}>
                <span className="text">{userProfile?.email}</span>
              </Col>
            </Row>
            <div className="mt-3">
              <Button
                onClick={() => navigate('/user/edit-profile')}
                type="primary"
                shape="round"
              >
                <i className="fa fa-edit pe-2" /> Edit Profile
              </Button>
              <Button
                type="default"
                onClick={() => navigate('/user/admin-dashboard')}
                shape="round"
                className="float-right px-5"
                style={{marginLeft:"2px"}}
              >
                Back To Dashboard
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Profile;
